import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Row, Col, Form, Input, Select, message, Spin, AutoComplete, Button as AntdButton, DatePicker, Divider, Space, Drawer, Modal } from 'antd';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Scrollbars } from 'react-custom-scrollbars';
import { useDispatch, useSelector } from 'react-redux';
import { PlusCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { useHistory } from "react-router-dom";
import FeatherIcon from 'feather-icons-react';
import juice from 'juice';
import { AddUser } from '../style';
import InitialData from '../Pages/InitialData.json'
import { setEditCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import { FetchContactDetails, FetchAllContact, FetchAllContactByDep } from '../../../Api/Services/ContactApiService'
import AddTaskPage from '../Pages/AddTask'
import DetailsPage from '../Pages/DetailsPage/Detailspage';
import RelatedTab from '../Pages/DetailsPage/RelatedTab';
import CaseFields from '../Pages/DetailsPage/CaseFields';
import CaseRightData from '../Pages/DetailsPage/CaseRightData'
import { RelatedDocUpload } from '../Pages/GlobalComponents/RelatedDocUpload'
import { getAllUsersData, FetchAllAttendeeList } from '../../../Api/Services/CommonApiService'
import { FetchRelatedEmails, FetchDetailspage } from '../../../Api/Services/EmailApiSevices'
import { getCompanyCase, deleteCase, FetchCaseDetails, updateCase, createCase } from '../../../Api/Services/CaseApiServices'
import { useExcryptedNavigation, useNavigationDecrypted } from '../Filters/FilterConditions';
import { LeadDetailData, FetchAllLead, FetchAllLeadByDep } from '../../../Api/Services/LeadApiServices'
// import { PageHeader } from '../../../components/page-headers/page-headers';
// import { Cards } from '../../../components/cards/frame/cards-frame';
import ComposeMail from '../Email/QSICompose';
import { Main, BasicFormWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import Heading from '../../../components/heading/heading';
import AllCancelPopup from '../Popup/AllCancelPopup';
import UpdateConnectionPopup from '../Popup/UpdateConnectionPopup';
import DefaultMessagePopup from '../Popup/DefaultMessagePopup'
import DeleteConnectionPopup from '../Popup/DeleteConnectionPopup';
import AddCasePopup from '../Popup/AddCasePopup'
import CallLogPopup from '../Popup/CallLogPopup'
import ConfirmationPopup from '../Popup/ConfirmationPopup'
import { EmailIcon, TaskIcon, CallLogIcon, CancelIcon, SaveIcon, DeleteIcon, EditIcon } from '../../../components/Icons/Icons';
import { mobileOnChangeValidator, validateShortText, nameOnChangeValidator, validateEmailField, validateDescriptionField } from '../../../components/utilities/utilities';

const { Option } = Select;

function AddNew({ UrlId, FromPage, setCratePage, GetAll, ShortCut, fromEmail, CallBack, MailData }) {
    const prevValues = useRef({ UrlId: "", FromPage: "" });
    const AutomationMessage = "Your action has triggered a business rule. Relevant validations, updates, or automated actions have been applied based on the configured logic."
    const { emailapiValues, emailactiontype } = useSelector((state) => state.EmailData);
    const dispatch = useDispatch();
    const localData = useSelector((state) => state.localRedux)
    const Role = localData.role
    const loadingRef = useRef(false);
    const [doubleClick, setDoubleClick] = useState(false)
    const [pages] = useState("Meeting")
    const [trigger, setTrigger] = useState("")
    const [NacTrigger, setNaCTrigger] = useState()
    const [validDate, setValidDate] = useState(null)
    const [popupMessage, setPopupMessage] = useState(false)
    const history = useHistory();
    const [taskProp, setTaskProp] = useState()
    const [form] = Form.useForm();
    const [popupType, setPopupType] = useState()
    const [displayData, setDisplayData] = useState()
    const [edit, setEdit] = useState(false)
    const [errorData, setErrorData] = useState([])
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const [caseId, setCaseId] = useState()
    const [allList, setAllList] = useState([])
    const [users, setUsers] = useState([])
    const [users2, setUsers2] = useState([])
    const [creatorList, setCreatorList] = useState()
    const [parentCase, setParentCase] = useState()
    const [editField, setEditField] = useState(false)
    const [assignee, setAssignee] = useState()
    const [threadContent, setThreadContent] = useState()
    const [FILEList, setFileList] = useState([]);
    const [addAccount, setAddAccount] = useState(false)
    const [createPageTask, setCreatePageTask] = useState()
    const [confirmPopup, setConfirmPopup] = useState(false)
    const [uiReady, setUiReady] = useState(false)
    const [deleteId, setDeleteId] = useState()
    const [isModalVisible1, setIsModalVisible1] = useState(false)
    const [callLogPopup, setCallLogPopup] = useState(false)
    const [notes, setNotes] = useState();
    const [allNotes, setAllNotes] = useState([]);
    const [leadInitial, setLeadInitial] = useState()
    const [requesterType, setRequesterType] = useState()
    const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false)
    const ProfileData = localData.profile
    const profile = ProfileData
    const companyProfile = localData.company
    const { ExcryptedNavigation } = useExcryptedNavigation();
    const onnavigate = () => {
        dispatch(setEditCall(false))
        history.push("/Home/email-config")
    }
    const disabledDate = current => {
        return current && current < moment().startOf('day');
    };
    const formatDate = (isoDateString) => {
        const date = new Date(isoDateString);
        const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const day = days[date.getUTCDay()];
        const month = months[date.getUTCMonth()];
        const dayOfMonth = date.getUTCDate();
        const year = date.getUTCFullYear();
        const hour = date.getUTCHours();
        const minute = date.getUTCMinutes();
        const formattedDate = `${day}, ${month} ${dayOfMonth} ${year} ${hour}:${minute < 10 ? `0${minute}` : minute}`;
        return formattedDate;
    };
    function normalizeEmailData(input) {
        const cleanString = (str) => str.trim().replace(/^["']|["']$/g, "");
        const parseEmail = (emailString) => {
            emailString = cleanString(emailString);
            const match = emailString.match(/(.*)<(.+)>/);
            if (match) {
                return {
                    name: cleanString(match[1]),
                    address: match[2].trim(),
                };
            }
            return {
                name: "",
                address: emailString,
            };
        };
        const normalizeField = (field) => {
            if (!field) return [];
            return field.split(",").map((item) => parseEmail(item.trim()));
        };
        const BodywithLinks = (data) => {
            const urlPattern = /(https?:\/\/[^\s]+)/g;
            const formattedMessage = data.replace(urlPattern, (url) => {
                const escapedUrl = encodeURIComponent(url);
                return `<a href="${escapedUrl}" target="_blank">${url}</a>`;
            });
            return formattedMessage.replace(/\n/g, '<br />');
        };
        const formattedFrom = parseEmail(input.from || "");
        const formattedTo = normalizeField(input.to || "");
        const formattedCc = normalizeField(input.cc || "");
        const formattedBcc = normalizeField(input.bcc || "");
        let bodyText = "";
        if (emailapiValues?.emailType === "Outlook") {
            bodyText = input ? input?.bodyContent ? input.bodyContent : "" : ""
        }
        else if (emailapiValues?.emailType === "Google" || emailapiValues?.emailType === "Zoho" || emailapiValues?.emailType === "Other Email") {
            bodyText = input ? (input?.htmlContent && input?.htmlContent !== "") ? input.htmlContent : input?.textContent ? BodywithLinks(input.textContent) : "" : ""
        }
        return {
            ...input,
            from: formattedFrom,
            to: formattedTo,
            cc: formattedCc,
            bcc: formattedBcc,
            body: bodyText,
        };
    }
    function normalizeEmailDataforOutlook(input) {
        let bodyText = "";
        if (emailapiValues?.emailType === "Outlook") {
            bodyText = input ? input?.bodyContent ? input.bodyContent : "" : ""
        }
        return {
            ...input,
            body: bodyText,
        };
    }
    const getattendeeFrom = (fromEmail, emailName, dataList) => {
        const user = dataList.find(u => u.email === fromEmail);
        const name = user?.name?.trim();
        const validData = name || emailName || fromEmail;
        return validData;
    };
    const [mailOpen, setMailOpen] = useState(false)
    const ViewDetailPage = (id, entity) => {
        ExcryptedNavigation("Nav", id, entity, history, dispatch, null, null)
    }
    const PageCancel = () => {
        dispatch(setEditCall(false))
        history.push('/Home/incidents')
    }
    const RequiredDateFormating = (dateString) => {
        if (dateString) {
            const parsedDate = moment(dateString, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
            const formattedDate = parsedDate.format("YYYY-MM-DD");
            return formattedDate;
        }
        return null;
    };
    const normalizeValue = (value) => {
        if (value === undefined || value === "") return null;
        return value;
    };
    // Deep equality check (order-insensitive for objects)
    const isEqual = (a, b) => {
        if (a === b) return true;

        if (typeof a !== typeof b) return false;

        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, i) => isEqual(item, b[i]));
        }

        if (typeof a === "object" && a !== null && b !== null) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            if (keysA.length !== keysB.length) return false;

            return keysA.every(key => isEqual(a[key], b[key]));
        }

        return false;
    };

    const getChangedFields = (newData, oldData) => {
        return Object.keys(newData).reduce((acc, key) => {
            if (!(key in oldData) || !isEqual(newData[key], oldData[key])) {
                acc[key] = newData[key];
            }
            return acc;
        }, {});
    };
    // const getChangedFields = (newData, oldData) => {
    //     return Object.keys(newData).reduce((acc, key) => {
    //         if (Array.isArray(newData[key]) && Array.isArray(oldData[key])) {
    //             if (JSON.stringify(newData[key]) !== JSON.stringify(oldData[key])) {
    //                 acc[key] = newData[key];
    //             }
    //         } else if (newData[key] !== oldData[key]) {
    //             acc[key] = newData[key];
    //         }
    //         return acc;
    //     }, {});
    // };
    const OnClickofDelete = (value) => {
        setConfirmPopup(true)
        setDeleteId(value)
    }
    const validateCode = (_, value) => {
        const allowedRegex = /^[A-Za-z0-9-]+$/;
        if (!allowedRegex.test(value)) {
            return Promise.reject(
                new Error("Only letters, numbers, and hyphens (-) are allowed")
            );
        }
        if (value.length > 15) {
            return Promise.reject(
                new Error("Account number cannot exceed 15 characters")
            );
        }
        const getList = allList
            .filter(item => item.caseId !== caseId)
        const existingCodes = getList.map(item => item.caseNumber)
        if (existingCodes.includes(value)) {
            return Promise.reject(new Error("This number already exists"));
        }
        return Promise.resolve();
    };
    const generateUniqueCode = (Code, existingData) => {
        let newCode;
        const existingCodes = new Set(existingData.map(item => item.caseNumber));
        do {
            const randomNumber = Math.floor(100000 + Math.random() * 900000);
            newCode = `${Code}-${randomNumber}`;
        } while (existingCodes.has(newCode));
        return newCode;
    };
    const getList = async (type) => {
        try {
            const data = await getCompanyCase()
            if (type === "Create") {
                const newCode = generateUniqueCode("CSE", data);
                form.setFieldsValue({
                    number: newCode,
                })
            }
            setAllList(data)
        }
        catch (error) {
            message.error(error)
        }
    }
    const successMessage = (titles, data) => {
        const modal = Modal.success({
            className: "Glitter-MessagePopup",
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, justifyContent: "center" }}>
                    <CheckCircleOutlined style={{ color: 'green', fontSize: 20 }} />
                    <span>{titles}</span>
                </div>
            ),
            content: <p>{data}</p>,
            centered: true,
            okButtonProps: { style: { display: 'none' } },
            closable: true,
            onCancel: () => modal.destroy(),
        });
    }
    async function deleteMenu(id) {
        try {
            const response = await deleteCase(id)
            if (response.status === 200) {
                if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                    setErrorData(response.data);
                    setIsModalVisible(true);
                    setConfirmPopup(false)
                } else {
                    const isAutomation = response.data[0].message === AutomationMessage;
                    dispatch(setEditCall(false))
                    if (isAutomation) {
                        successMessage("Automation rule triggered", response.data[0].message);

                    } else {
                        message.success(
                            <span>
                                Incident <strong>{response?.data?.[0]?.entityName}</strong> has been deleted successfully
                            </span>
                        );
                    }
                    // setTimeout(() => {
                    // dispatch(setEditCall(false))
                    history.push('/Home/incidents')
                    // }, 1000);
                }
            }
        } catch (error) {
            message.error(error)
        }
    }
    const convertTime = (timeStr, timeFormat) => {
        let hours;
        let minutes;
        // let seconds;
        let period;
        if (timeStr.toLowerCase().includes('am') || timeStr.toLowerCase().includes('pm')) {
            // Parse 12-hour time string
            const timeParts = timeStr.match(/(\d{1,2}):(\d{2}):?(\d{2})?/);
            hours = parseInt(timeParts[1], 10);
            minutes = parseInt(timeParts[2], 10);
            // seconds = parseInt(timeParts[3], 10);
            period = timeStr.match(/(am|pm)/i)[0].toLowerCase();

            if (period === 'pm' && hours !== 12) {
                hours += 12;
            } else if (period === 'am' && hours === 12) {
                hours = 0;
            }
        } else {
            // Parse 24-hour time string
            const timeParts = timeStr.split(':');
            hours = parseInt(timeParts[0], 10);
            minutes = parseInt(timeParts[1], 10);
            // seconds = parseInt(timeParts[2], 10);
        }
        if (timeFormat === '12hrs' || timeFormat === '12-hour') {
            period = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12;
            // return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')} ${period}`;
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${period}`;
        }
        // No need for an else here because we return in the if above
        if (timeFormat === '24hrs' || timeFormat === '24-hour') {
            // return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
        }
        throw new Error('Invalid time format specified');
    };
    const formatDateString = (dateString, format) => {
        return moment(dateString, "YYYY-MM-DD").format(format);
    };
    async function setInitialData(value) {
        setLeadInitial({
            caseSubject: normalizeValue(value.caseSubject),
            caseNumber: normalizeValue(value.caseNumber),
            caseOwner: normalizeValue(value.caseOwner),
            caseType: normalizeValue(value.caseType),
            caseOrigin: normalizeValue(value.caseOrigin),
            casePriority: normalizeValue(value.casePriority),
            caseStatus: normalizeValue(value.caseStatus),
            accountName: normalizeValue(value.accountName),
            caseCreater: normalizeValue(value.caseCreater),
            solution: normalizeValue(value.solution),
            comment: normalizeValue(value.comment),
            description: normalizeValue(value.description),
            caseCreaterEmail: normalizeValue(value.caseCreaterEmail),
            caseCreaterNumber: normalizeValue(value.caseCreaterNumber),
            uploadFile: (value.uploadFile || []),
            followers: normalizeValue(value.followers),
            requestedResolutionDate: normalizeValue(value.requestedResolutionDate),
            parentCase: normalizeValue(value.parentCase),
            childCase: normalizeValue(value.childCase),
            requesterType: normalizeValue(value.requesterType)
        })
    }
    async function setData(value) {
        if (value !== undefined) {
            form.setFieldsValue({
                subject: value.caseSubject,
                number: value.caseNumber,
                caseOwner: value.caseOwner,
                type: value.caseType,
                status: value.caseStatus,
                origin: value.caseOrigin,
                priority: value.casePriority,
                reason: value.caseReason,
                creator: value.caseCreater,
                email: value.caseCreaterEmail,
                phone: value.caseCreaterNumber,
                accountname: value.accountName,
                description: value.description,
                solution: value.solution,
                comment: value.comment,
                followers: value.followers ? value.followers.split(",").map(user => user * 1) : [],
                childCases: value.childCase ? value.childCase.split(",").map(user => user * 1) : [],
                parentCase: value.parentCase,
                isssueDate: value.requestedResolutionDate !== "" && value.requestedResolutionDate !== null ?
                    moment(formatDateString(value.requestedResolutionDate, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"), profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
                    : null,
            })
            setRequesterType(value.requesterType)
            setValidDate(value.requestedResolutionDate)
            setParentCase(value.parentCase)
            setAssignee(value.caseOwner)
            if (value.internalComments && value.internalComments !== '[]' && value.internalComments !== '') {
                setAllNotes(value.internalComments);
            } else {
                setAllNotes([]);
            }
            setFileList(value.uploadFile || [])
            setCaseId(value.caseId)
        }
    }
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            const options = data.filter(item => item.department === "Sales" || item.department === "Customer Care").map((option, i) => (
                <Option value={option.userId} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                    < img src={option.profilePic} alt="profile" />
                                    :
                                    <span className="image_icon UserIcon">
                                        {option.firstName.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                            </div>
                        </div>
                    </div>
                    // <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    //     {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                    //         < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                    //         :
                    //         <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                    //             {option.firstName.slice(0, 1).toUpperCase()}
                    //         </span>
                    //     }
                    //     <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                    // </div>
                )}>
                    <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                        <div>
                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.firstName.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                            <p style={{ margin: 0 }}>{option.username}</p>
                        </div>
                    </div>
                </Option>));
            setUsers(options)
            setUsers2(data)
        } catch (error) {
            message.error(error)
        }
    }
    const getUserDetail = async () => {
        if (UrlId === undefined || UrlId === null) {
            if (profile.department === "Customer Care" || profile.department === "Sales") {
                form.setFieldsValue({
                    caseOwner: profile.userId
                });
                setAssignee(profile.userId)
            } else {
                form.setFieldsValue({
                    followers: [profile.userId]
                });
            }
        }
    }
    const setEmailDataToCase = async (data, creatorList) => {
        const fromAddress = data?.from?.address || data?.from?.email;
        const matchedEntry = creatorList.find(entry => entry.email === fromAddress);
        if (matchedEntry) {
            setDisabled(true)
            if (matchedEntry?.type === "Leads") {
                try {
                    const responseData = await LeadDetailData(matchedEntry.id)
                    const response = responseData.data
                    form.setFieldsValue({
                        subject: data?.subject,
                        // caseOwner: null,
                        type: null,
                        isssueDate: null,
                        phone: response?.phone && response?.phone !== "" ? response?.phone :
                            response?.mobile && response?.mobile !== "" ? response?.mobile : null,
                        creator: `${response?.first_name} ${response?.last_name}`, email: response?.primary_email,
                        accountname: response.account_name,
                    })
                    setRequesterType("Leads")
                }
                catch (error) {
                    message.error(error)
                }
            }
            if (matchedEntry?.type === "Contacts") {
                try {
                    const responseData = await FetchContactDetails(matchedEntry.id)
                    const response = responseData.data
                    form.setFieldsValue({
                        subject: data?.subject,
                        // caseOwner: null,
                        type: null,
                        isssueDate: null,
                        phone: response?.phone && response?.phone !== "" ? response?.phone :
                            response?.mobile && response?.mobile !== "" ? response?.mobile : null,
                        creator: `${response?.first_name} ${response?.last_name}`, email: response?.email,
                        accountname: response.account_name,
                    })
                    setRequesterType("Contacts")
                }
                catch (error) {
                    message.error(error)
                }
            }
        }
        else {
            setTimeout(() => {
                form.setFieldsValue({
                    subject: data?.subject,
                    // caseOwner: null,
                    type: null,
                    creator: data?.from?.name,
                    email: data?.from?.email,
                    accountname: null,
                    phone: null,
                    isssueDate: null,
                })
                setRequesterType("Others")
            }, 1000);
        }
        getUserDetail()
    }
    async function CreatorListApi(type, emailData) {
        try {
            let Lead;
            let contact;
            if (profile.department === "Customer Care" || profile.department === "Marketing") {
                Lead = await FetchAllLeadByDep()
                contact = await FetchAllContactByDep()
            }
            else {
                Lead = await FetchAllLead()
                contact = await FetchAllContact()
            }
            const formattedLeads = Lead.map(item => ({
                id: item.leads_id,
                name: `${item.first_name} ${item.last_name}`,
                email: item.primary_email,
                type: "Leads",
            }));
            const formattedContacts = contact.map(item => ({
                id: item.contacts_id,
                name: `${item.first_name} ${item.last_name}`,
                email: item.email,
                type: "Contacts",
            }));
            const options = [...formattedLeads, ...formattedContacts];
            setCreatorList(options)
            if (displayData.caseCreater) {
                const exists = options?.some((item) => item.name === displayData.caseCreater);
                if (displayData.caseCreater && exists) {
                    setDisabled(true)
                }
            }
            if (type === "fromEmail") {
                setEmailDataToCase(emailData, options)
            }
        }
        catch (error) {
            message.error(error)
        }
    }
    const CloseDrawer = () => {
        setCancelConfirmOpen(false)
        form.setFieldsValue({
            subject: null,
            number: null,
            caseOwner: null,
            type: null,
            status: null,
            origin: null,
            priority: null,
            reason: null,
            creator: null,
            email: null,
            phone: null,
            accountname: null,
            description: null,
            solution: null,
            comment: null,
            followers: [],
            childCases: [],
            parentCase: null,
            isssueDate: null,
        })
        setValidDate()
        setParentCase()
        setAssignee()
        setAllNotes([]);
        setFileList([])
        setRequesterType()
        setDisabled(false)
        if (FromPage !== "EntityUpdate" && ShortCut !== "Shortcut" && fromEmail !== "fromEmail") {
            GetAll();
            setCratePage();
        }
        if (ShortCut === "Shortcut") {
            setCratePage()
        }
        if (fromEmail === "fromEmail") {
            setCratePage()
        }
        setEdit(false);
        setEditField(false);
        dispatch(setEditCall(false))
    }
    const CloseDrawerNew = () => {
        setCancelConfirmOpen(false)
        setDisabled(false)
        setEdit(false);
        setEditField(false);
        dispatch(setEditCall(false))
    }
    async function getCaseData(caseId) {
        try {
            const response = await FetchCaseDetails(caseId)
            if (!response.allow) throw new Error();
            setData(response.data);
            setInitialData(response.data);
            setDisplayData(response.data)
        } catch (error) {
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    async function getCaseData1(caseId, hideMessage, isAutomation, updateResponse) {
        try {
            const response = await FetchCaseDetails(caseId)
            hideMessage();
            if (isAutomation) {
                successMessage("Automation rule triggered", updateResponse.data[0].message);
            } else {
                message.success(
                    <span>
                        Incident <strong>{updateResponse?.data?.[0]?.entityName}</strong> has been updated successfully
                    </span>
                );
            }
            if (!response.allow) throw new Error();
            setData(response.data);
            setInitialData(response.data);
            setDisplayData(response.data)
            setTrigger("activity")
            loadingRef.current = false;
            setDoubleClick(false)
            CloseDrawerNew()
        } catch (error) {
            hideMessage();
            loadingRef.current = false;
            setDoubleClick(false)
            if (isAutomation) {
                successMessage("Automation rule triggered", updateResponse.data[0].message);
            } else {
                message.success(
                    <span>
                        Incident <strong>{updateResponse?.data?.[0]?.entityName}</strong> has been updated successfully
                    </span>
                );
            }
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    const { NavigationDecrypted } = useNavigationDecrypted();
    async function getEntityAvalibitlity() {
        let dataFound = true;
        if (UrlId[0] === '?FCASE') {
            try {
                const response = await NavigationDecrypted(UrlId[1])
                if (response) {
                    setCaseId(response)
                    dataFound = true;
                    getCaseData(response)
                }
                else {
                    dataFound = false;
                }
            } catch (error) {
                dataFound = false;
            }
        }
        if (UrlId[0] === '?CASE') {
            try {
                const response = await NavigationDecrypted(UrlId[1])
                if (response) {
                    setCaseId(response)
                    dataFound = true;
                    getCaseData(response)
                } else {
                    dataFound = false;
                }
            } catch (error) {
                dataFound = false;
            }
        }
        if (!dataFound) {
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    const scroolup = () => {
        const currentPosition = window.scrollY;
        if (currentPosition > 0) {
            const scrollStep = Math.max(1, Math.ceil(currentPosition / 20));
            window.scrollTo(0, currentPosition - scrollStep);
            requestAnimationFrame(scroolup);
        }
    }
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
        scroolup()
    }
    const Callback = (newCaseId) => {
        const currentCases = form.getFieldValue("childCases") || [];
        const updatedCases = [...new Set([...currentCases, newCaseId])];
        form.setFieldsValue({
            childCases: updatedCases
        });
    };
    const fetchAll = async () => {
        await Promise.allSettled([
            UserDetailsApi(),
            CreatorListApi(fromEmail, MailData)
        ])
        setUiReady(true)
    };
    useEffect(() => {
        if (FromPage && editField && displayData) {
            fetchAll();
        }
    }, [FromPage, editField, displayData])
    useEffect(() => {
        if (FromPage) {
            scroolup()
        }
    }, [FromPage])
    useEffect(() => {
        const currentUrlId = JSON.stringify(UrlId); // <-- serialize for comparison
        const currentFromPage = FromPage;
        if (
            prevValues.current.UrlId === currentUrlId &&
            prevValues.current.FromPage === currentFromPage
        ) {
            return;
        }
        prevValues.current = {
            UrlId: currentUrlId,
            FromPage: currentFromPage,
        };
        if (FromPage) {
            // if (creatorList) { 
            if (FromPage === "EntityUpdate") {
                getEntityAvalibitlity()
                getList("Update")
            } else {
                form.setFieldsValue({
                    subject: undefined,
                    number: undefined,
                    caseOwner: undefined,
                    type: undefined,
                    status: "New",
                    origin: undefined,
                    priority: "Medium",
                    reason: undefined,
                    creator: undefined,
                    email: undefined,
                    phone: undefined,
                    accountname: undefined,
                    description: undefined,
                    solution: undefined,
                    comment: undefined,
                    followers: [],
                    childCases: [],
                    parentCase: undefined,
                    isssueDate: null,
                })
                if (fromEmail === "fromEmail") {
                    form.setFieldsValue({
                        origin: "Email"
                    })
                } else {
                    getUserDetail()
                }
                setRequesterType()
                setLeadInitial(InitialData.CaseData)
                setDisplayData("Create")
                getList("Create")
                setParentCase()
                setCaseId()
                setEdit(true)
                setEditField(true)
            }
            // }
        }
    }, [UrlId, FromPage]);
    const HandleIsModalVisible = (value) => {
        setIsModalVisible(value)
    }
    function convertAndFormatDateTime2(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
        const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
        const timeFormat = profile?.timeFormat && profile?.timeFormat !== "" ? profile.timeFormat : "24hrs";
        const formattedDate = converted.format(dateFormat);
        const rawTime = converted.format("HH:mm");
        const formattedTime = convertTime(rawTime, timeFormat);

        return `${formattedDate} ${formattedTime}`
    }
    function convertAndFormatDateTime(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
        const dateFormat = "YYYY-MM-DD";
        const timeFormat = "24hrs";
        const formattedDate = converted.format(dateFormat);
        const rawTime = converted.format("HH:mm");
        const formattedTime = convertTime(rawTime, timeFormat);

        return `${formattedDate} ${formattedTime}`
    }
    function getCurrentDateTimeFromZoneString(tzStr) {
        if (!tzStr) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const timezone = extractTimezoneName(tzStr)
        if (!moment.tz.zone(timezone)) {
            console.warn("Invalid timezone:", timezone);
            return "";
        }
        return moment.tz(timezone).format("YYYY-MM-DD HH:mm");
    }
    const handleSelect = async (value) => {
        setDisabled(true)
        form.setFieldsValue({
            creator: value.name,
            email: value.email,
        })
        if (value.type === "Contacts") {
            try {
                const responseData = await FetchContactDetails(value.id)
                const response = responseData.data
                form.setFieldsValue({
                    accountname: response.account_name
                })
            }
            catch (error) {
                message.error(error)
            }
            setRequesterType("Contacts")
        }
        else if (value.type === "Leads") {
            try {
                const responseData = await LeadDetailData(value.id)
                const response = responseData.data
                form.setFieldsValue({
                    accountname: response.account_name
                })
            }
            catch (error) {
                message.error(error)
            }
            setRequesterType("Leads")
        }
        else {
            setRequesterType("Others")
        }
    };
    const handleCreatorChange = () => {
        form.setFieldsValue({
            email: undefined,
            accountname: undefined,
        });
        setDisabled(false);
        setRequesterType("Others")
    };
    const CreateMail = async () => {
        setThreadContent()
        if (emailactiontype) {
            setPopupMessage(true)
        }
        else {
            let hideMessage;
            try {
                hideMessage = message.loading("Loading thread...", 0);
                const [allattendeeData, data] = await Promise.all([
                    FetchAllAttendeeList(),
                    FetchRelatedEmails(caseId, "Case", 1)
                ]);
                const allList = data?.sort((a, b) => {
                    const dateA = a.actionDate ? moment(convertAndFormatDateTime(a.actionDate, companyProfile, profile), "YYYY-MM-DD HH:mm") : null;
                    const dateB = b.actionDate ? moment(convertAndFormatDateTime(b.actionDate, companyProfile, profile), "YYYY-MM-DD HH:mm") : null;
                    if (!dateA || !dateB) return 0;
                    return dateB - dateA;
                })
                if (Array.isArray(allList) && allList.length > 0) {
                    const LastMail = allList[0]
                    if (profile?.userId !== LastMail?.linkedBy) {
                        setThreadContent()
                        setNaCTrigger("trigger")
                        setMailOpen(true)
                        hideMessage()
                        return;
                    }
                    if (LastMail.mailServer !== emailapiValues?.emailType) {
                        setThreadContent()
                        setNaCTrigger("trigger")
                        setMailOpen(true)
                        hideMessage()
                        return;
                    }
                    const mailresponse = await FetchDetailspage(LastMail.sourceId, LastMail.actionType === "Recived" ? "INBOX" : LastMail.actionType === "Sent" ? "Sent" : "")
                    let modifiedData;
                    const originalData = mailresponse.data;
                    if (emailapiValues?.emailType === 'Outlook') {
                        modifiedData = normalizeEmailDataforOutlook(originalData)
                    } else if (emailapiValues?.emailType === 'Google' || emailapiValues?.emailType === 'Zoho' || emailapiValues?.emailType === "Other Email") {
                        modifiedData = normalizeEmailData(originalData);
                    };
                    const enrichedData = {
                        ...modifiedData,
                        from: {
                            ...modifiedData.from,
                            name: emailapiValues?.email === modifiedData?.from?.address ? `${profile?.firstName} ${profile?.lastName}` : getattendeeFrom(modifiedData?.from?.address, modifiedData?.from?.name, allattendeeData),
                        },
                    };
                    const { date, from, body } = enrichedData;
                    const inlinedHtml = juice(body);
                    const finalHtml = inlinedHtml
                        .replace(/<!DOCTYPE html>/, '')
                        .replace(/<html[^>]*>/, '')
                        .replace(/<\/html>/, '')
                        .replace(/<head>.*<\/head>/s, '')
                        .replace(/<body[^>]*>/, match => {
                            const bodyStyleMatch = match.match(/style="([^"]*)"/);
                            return `<div style="${bodyStyleMatch ? bodyStyleMatch[1] : ''}">`;
                        })
                        .replace('</body>', '</div>')
                        .trim();
                    const emailContent = `
                            <div> </div>
                            <div contenteditable="false" id="ReplyContent">
                            <hr style="border: 1px solid #ccc; margin: 20px 0;" />
                            <div class="quoted">
                            <div>---- On ${formatDate(date)}, <strong>${from?.address || from.email}</strong> wrote ----</div>
                            <blockquote>
                            ${finalHtml}
                            </blockquote>
                            </div> 
                            </div>
                          `;
                    setThreadContent(emailContent)
                    setNaCTrigger("trigger")
                    setMailOpen(true)
                    hideMessage()
                }
                else {
                    setThreadContent()
                    setNaCTrigger("trigger")
                    setMailOpen(true)
                    hideMessage()
                }
            }
            catch (error) {
                hideMessage()
                message.error(error);
            }
        }
    }
    const closeMailComposr = () => {
        setMailOpen(false);
    };
    const SubjectData = `[${displayData?.caseNumber}] ${displayData?.caseSubject}`;
    const dealrestartDateChange2 = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setValidDate(formattedDate);
    };
    const handleCallLogClick = (value) => {
        setCallLogPopup(true)
        setPopupType(value)
        setNaCTrigger("trigger")
    }
    const CreateTask = (id) => {
        setCreatePageTask("ListingLead")
        setNaCTrigger("trigger")
        setTaskProp({
            type: "Case",
            ids: [id]
        })
    }
    const ButtonActions = [
        {
            Actions: <div className='Hover-Refresh2 back-hover1 able-style'
                role="button"
                tabIndex={0} title='Send Email'
                onClick={() => CreateMail()}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        CreateMail()
                    }
                }}
                aria-label='mail'
            > <EmailIcon height={20} width={20} /></div>
        },
        {
            Actions: <div className='Hover-Refresh2 back-hover1 able-style'
                role="button"
                tabIndex={0} title='Create Task'
                onClick={() => CreateTask(caseId)}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        CreateTask(caseId)
                    }
                }}
                aria-label='task'
            > <TaskIcon height={20} width={20} /></div>
        },
        {
            Actions: <div className='Hover-Refresh2 back-hover1 able-style'
                role="button"
                tabIndex={0} title='Log a Call'
                onClick={() => handleCallLogClick("Create")}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        handleCallLogClick("Create")
                    }
                }}
                aria-label='phone'
            > <CallLogIcon height={20} width={20} /></div>
        },
    ]
    const moreAction = "No"
    const MoreAction = () => (<></>)
    const LeadInfos = {
        profile: undefined,
        Classname: " ",
        letterIcon: displayData?.caseSubject,
        name: displayData?.caseSubject,
        subName: `${displayData?.caseNumber}`,
        mainAction: undefined,
    }
    const getDetailsDatas = useCallback(() => getCaseData(caseId), [caseId]);
    const LeadDetails = (<CaseFields displayData={displayData} getDetailsData={getDetailsDatas} />);
    const RelatedDetails = (<RelatedTab EntityType="Case" UrlId={UrlId ? [UrlId[0], caseId] : null} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} profile={profile} emailactiontype={emailapiValues} trigger={trigger} displayData={displayData} />)
    const RightRelatedDetails = (<CaseRightData displayData={displayData} profile={profile} ViewDetailPage={ViewDetailPage} Role={Role} setNaCTrigger={setNaCTrigger} />)
    const handleEditChange = () => {
        setEditField(true)
        setEdit(true)
        dispatch(setEditCall(true))
    }
    const setProjectNotesData = (value) => {
        if (value.internalComments && value.internalComments !== '[]' && value.internalComments !== '') {
            setAllNotes(value.internalComments);
        } else {
            setAllNotes([]);
        }
    };
    async function getProjectNotesById(id) {
        try {
            const response = await FetchCaseDetails(id)
            setProjectNotesData(response.data);
        } catch (error) {
            message.error(error);
        }
    }
    const handleAddNote = async () => {
        const data = {
            id: profile.userId,
            name: `${profile.firstName} ${profile.lastName}`,
            time: getCurrentDateTimeFromZoneString(companyProfile?.timeZone),
            content: notes,
        };
        setAllNotes((prevNotes) => [data, ...prevNotes]);
        setNotes('');
        const NewNotes = [data, ...allNotes]
        const formData = {
            internalComments: NewNotes,
        };
        try {
            const response = await updateCase(formData, caseId)
            if (response.status === 200) {
                if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                    setErrorData(response.data);
                    setIsModalVisible1(true);
                }
                else {
                    const isAutomation = response.data[0].message === AutomationMessage;
                    if (isAutomation) {
                        successMessage("Automation rule triggered", response.data[0].message);
                    }
                    getProjectNotesById(caseId)
                }
            }
            setNotes('');
        } catch (error) { message.error(error) }
    };
    const NoteDelete = async (id) => {
        const updatedFormData = [...allNotes];
        updatedFormData.splice(id, 1);
        setAllNotes(updatedFormData);
        const formData = {
            internalComments: updatedFormData,
        };
        try {
            const response = await updateCase(formData, caseId)
            if (response.status === 200) {
                if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                    setErrorData(response.data);
                    setIsModalVisible1(true);
                }
                else {
                    const isAutomation = response.data[0].message === AutomationMessage;
                    if (isAutomation) {
                        successMessage("Automation rule triggered", response.data[0].message);
                    }
                    getProjectNotesById(caseId)
                }
            }
            setNotes('');
        } catch (error) { message.error(error) }
    }
    const EditOpenForDrawer = () => {
        setEdit(true)
        dispatch(setEditCall(true))
    }
    const CloseDrawer2 = () => {
        scroolup()
        setEditField(false)
        getCaseData(caseId)
        setEdit(false);
        dispatch(setEditCall(false))
    }
    const PageCancel1 = () => {
        if (FromPage === "EntityUpdate") {
            CloseDrawer2()
        }
        else {
            setCancelConfirmOpen(true)
        }
    }
    const parseIds = (value) => {
        if (!value) return [];
        if (Array.isArray(value)) return value;

        return value
            .split(",")
            .map(id => Number(id.trim()))
            .filter(Boolean);
    };
    const addChildToParent = async (parentId, childId) => {
        const parentData = await FetchCaseDetails(parentId);
        const existingChildren = parseIds(parentData?.data?.childCase);
        if (existingChildren.includes(childId)) return;
        const updatedChildren = [...existingChildren, childId].join(',');
        return updateCase({ childCase: updatedChildren }, parentId);
    };
    const removeChildFromParent = async (parentId, childId) => {
        const parentData = await FetchCaseDetails(parentId);
        const existingChildren = parseIds(parentData?.data?.childCase);
        const updatedChildren = existingChildren.filter(id => id !== childId);
        return updateCase({
            childCase: updatedChildren.length > 0 ? updatedChildren.join(',') : null
        }, parentId);
    };
    const syncCaseRelations = async ({
        caseId,
        prevChildIds = [],
        newChildIds = [],
        prevParentId = null,
        newParentId = null,
    }) => {
        try {
            const promises = [];
            const prevSet = new Set(prevChildIds);
            const newSet = new Set(newChildIds);
            newChildIds.forEach(childId => {
                if (!prevSet.has(childId) && childId !== caseId) {
                    promises.push(
                        updateCase({ parentCase: caseId }, childId)
                    );
                }
            });
            prevChildIds.forEach(childId => {
                if (!newSet.has(childId)) {
                    promises.push(
                        updateCase({ parentCase: null }, childId)
                    );
                }
            });
            if (prevParentId !== newParentId) {
                if (prevParentId) {
                    promises.push(removeChildFromParent(prevParentId, caseId));
                }
                if (newParentId && newParentId !== caseId) {
                    promises.push(addChildToParent(newParentId, caseId));
                }
            }
            await Promise.all(promises);
        } catch (err) {
            console.error("Relation sync failed", err);
        }
    };
    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDoubleClick(true)
        let hideMessage;
        const { subject, number, caseOwner, type, status, origin, priority, creator, email, phone, accountname, description, solution, comment, followers, childCases, parentCase } = values;
        const payload = {
            caseSubject: normalizeValue(subject),
            caseNumber: normalizeValue(number),
            caseOwner: normalizeValue(caseOwner),
            caseType: normalizeValue(type),
            caseOrigin: normalizeValue(origin),
            casePriority: normalizeValue(priority),
            caseStatus: normalizeValue(status),
            accountName: normalizeValue(accountname),
            caseCreater: normalizeValue(creator),
            solution: normalizeValue(solution),
            comment: normalizeValue(comment),
            description: normalizeValue(description),
            caseCreaterEmail: normalizeValue(email),
            caseCreaterNumber: normalizeValue(phone),
            uploadFile: FILEList,
            followers: (followers && followers.length > 0) ? followers.join(',') : null,
            requestedResolutionDate: normalizeValue(validDate),
            parentCase: normalizeValue(parentCase),
            childCase: (childCases && childCases.length > 0) ? childCases.join(',') : null,
            requesterType: normalizeValue(requesterType)

        }
        const updatedFields = getChangedFields(payload, leadInitial);
        if (Object.keys(updatedFields).length === 0) {
            getCaseData(caseId)
            scroolup()
            setTrigger("activity")
            message.success("Incident updated")
            loadingRef.current = false;
            setDoubleClick(false)
            CloseDrawerNew()
            return;
        }
        try {
            hideMessage = message.loading("Loading...", 0);
            if (FromPage === "EntityUpdate") {
                const response = await updateCase(updatedFields, caseId)
                if (response.status === 200) {
                    const prevChildIds = parseIds(displayData?.childCase);
                    const newChildIds = parseIds(updatedFields?.childCase);
                    const prevParentId = displayData?.parentCase || null;
                    const newParentId = updatedFields?.parentCase || null;
                    await syncCaseRelations({
                        caseId,
                        prevChildIds,
                        newChildIds,
                        prevParentId,
                        newParentId,
                    });
                    if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                        setErrorData(response.data);
                        setIsModalVisible1(true);
                        loadingRef.current = false;
                        setDoubleClick(false)
                        hideMessage();
                    }
                    else {
                        const isAutomation = response.data[0].message === AutomationMessage;
                        const ownerChanged = displayData.caseOwner !== caseOwner;
                        if (ownerChanged) {
                            hideMessage()
                            if (isAutomation) {
                                successMessage("Automation rule triggered", response.data[0].message);
                            } else {
                                message.success(
                                    <span>
                                        Incident <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully
                                    </span>
                                );
                            }
                            dispatch(setEditCall(false));
                            history.push('/Home/incidents')
                        }
                        else {
                            getCaseData1(caseId, hideMessage, isAutomation, response)
                            scroolup()
                        }
                    }
                }
            }
            else {
                const response = await createCase(updatedFields)
                if (response.status === 201) {
                    const newCaseId = response.data.caseId;
                    const newChildIds = parseIds(updatedFields?.childCase);
                    const newParentId = updatedFields?.parentCase || null;
                    await syncCaseRelations({
                        caseId: newCaseId,
                        prevChildIds: [],
                        newChildIds,
                        prevParentId: null,
                        newParentId,
                    });
                    const isAutomation = response?.data?.message === AutomationMessage;
                    hideMessage();
                    dispatch(setEditCall(false))
                    if (isAutomation) {
                        successMessage("Automation rule triggered", response?.data?.message);
                        if (ShortCut === "Shortcut") {
                            history.push('/Home/incidents')
                        }
                        if (fromEmail === "fromEmail") {
                            CallBack(response.data.caseId)
                        }
                    } else {
                        message.success(response?.data?.message);
                        if (ShortCut === "Shortcut") {
                            history.push('/Home/incidents')
                        }
                        if (fromEmail === "fromEmail") {
                            CallBack(response.data.caseId)
                        }
                    }
                    loadingRef.current = false;
                    setDoubleClick(false)
                    CloseDrawer();
                }
            }
        }
        catch (error) {
            hideMessage();
            loadingRef.current = false;
            setDoubleClick(false)
            message.error(error);
        }
    }
    const getRefreshtheTable = () => {
        scroolup()
        getCaseData(caseId)
        dispatch(setEditCall(false))
        setEditField(false)
        setEdit(false)
        setTrigger("activity")
        CloseDrawer();
        setRequesterType()
    }
    const handleAssigneeChange = (newAssigneeId) => {
        const prevAssignee = assignee; // this is the old one from state
        const currentFollowers = form.getFieldValue("followers") || [];
        let updatedFollowers = currentFollowers.filter((id) => id !== newAssigneeId);

        if (
            prevAssignee &&
            prevAssignee !== newAssigneeId &&
            !updatedFollowers.includes(prevAssignee)
        ) {
            updatedFollowers = [...updatedFollowers, prevAssignee];
        }

        form.setFieldsValue({
            caseOwner: newAssigneeId,
            followers: updatedFollowers,
        });

        setAssignee(newAssigneeId); // now update for next time
    };
    const handleParentCaseChange = (newParentId) => {
        // Update parent case in state
        setParentCase(newParentId);

        // Get current selected child cases
        const currentChildren = form.getFieldValue("childCases") || [];

        // Remove the parent from children list if it's there
        const updatedChildren = currentChildren.filter(
            (childId) => childId !== newParentId
        );

        form.setFieldsValue({
            parentCase: newParentId,
            childCases: updatedChildren,
        });
    };
    return (
        <>
            {FromPage === "EntityUpdate" ?
                <Main>
                    {displayData ? <>
                        {FromPage === "EntityUpdate" &&
                            <DetailsPage PageCancel={PageCancel} handleEditChange={handleEditChange} entity={UrlId ? UrlId[0] : '?CASE'} moreAction={moreAction}
                                DetailsPageMoreAction={<MoreAction />} ButtonActions={ButtonActions} Maincontent={LeadInfos} UpdateDataPage={undefined}
                                EntityTabDetails={LeadDetails} EntityRelatedTab={RelatedDetails} RightRelatedDetails={RightRelatedDetails}
                            />}
                    </>
                        :
                        <div className="spin">
                            <Spin />
                        </div>}
                </Main> : <></>}
            <Drawer
                className='Drawer-Header-Pages'
                bodyStyle={{ padding: 0 }}
                title={
                    FromPage === "EntityUpdate" ?
                        <span>
                            Update Incident
                            {displayData?.caseSubject && (
                                <>
                                    <span style={{
                                        margin: '0 10px',
                                        color: '#d9d9d9',
                                        fontWeight: 'normal'
                                    }}>|</span>
                                    <span style={{ fontWeight: 'normal' }}>
                                        {displayData?.caseSubject}
                                    </span>
                                </>
                            )}
                        </span>
                        : "Create Incident"
                }
                closable={false}
                placement="right"
                open={editField}
                width="80%"
                extra={
                    <Space>
                        {!edit ?
                            <div className='Hover-Refresh2 back-hover1 able-style'
                                role="button"
                                tabIndex={0} title='Edit'
                                onClick={() => EditOpenForDrawer()}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        EditOpenForDrawer()
                                    }
                                }}
                                aria-label='edit'
                            > <EditIcon height={20} width={20} /></div> : <></>}
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close'
                            onClick={() => PageCancel1()}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    PageCancel1()
                                }
                            }}
                            aria-label='Close'
                        > <CancelIcon width={24} height={24} /></div>
                    </Space>
                }
                footer={
                    (uiReady && edit) ? [
                        <div className="form_action_button">
                            <Button
                                className="gray-button" size="small"
                                onClick={() => PageCancel1()}
                            >
                                <CancelIcon height={25} width={25} />Cancel
                            </Button>
                            {FromPage === "EntityUpdate" ?
                                <Button
                                    className="red-button" size="small"
                                    onClick={() => OnClickofDelete(caseId)}
                                >
                                    <DeleteIcon height={25} width={25} />Delete
                                </Button> : <></>}
                            <Button size="small" htmlType="submit" className="button_colors" onClick={() => form.submit()} loading={doubleClick} disabled={doubleClick}>
                                {!doubleClick && <SaveIcon height={25} width={25} />}{FromPage === "EntityUpdate" ? "Update" : "Save"}
                            </Button>
                        </div>] : false
                }
            >
                {(uiReady && displayData) ? <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
                    <AddUser>
                        <div className="user-info-form">
                            <Form style={{ width: '100%' }} form={form} name="info" onFinish={onSubmit} onFinishFailed={onFinishFailed} colon={false}>
                                <BasicFormWrapper>
                                    <div className="add-product-block">
                                        <div style={{ margin: 40 }}>
                                            <Row gutter={15}>
                                                <Col xs={24}>
                                                    <div className="add-product-content">
                                                        <Heading as="h5">Basic Information</Heading>
                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Incident Subject" name="subject" id="subject" rules={edit ? [{ required: true, message: 'Please enter incident subject' }, {
                                                                    validator: (_, value) => {
                                                                        const error = validateShortText(value, 50);
                                                                        if (error) {
                                                                            return Promise.reject(new Error(error));
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                },
                                                                ] : [{ required: false }]}>
                                                                    {edit ? <Input placeholder="Enter Incident Subject" /> :
                                                                        <span>{displayData?.caseSubject}</span>
                                                                    }
                                                                </Form.Item>
                                                            </Col>

                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Incident Number" name="number" id="number" rules={edit ? [{ required: true, message: 'Please enter incident number' }, { validator: validateCode }] : [{ required: false }]}>
                                                                    {edit ? <Input placeholder="Enter Incident Number" /> :
                                                                        <span>{displayData?.caseNumber}</span>
                                                                    }
                                                                </Form.Item>
                                                            </Col>

                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Assignee" name="caseOwner" id="caseOwner" rules={edit ? [{ required: true, message: 'Please select incident owner' }] : [{ required: false }]}>
                                                                    {edit ? <Select style={{ width: '100%' }}
                                                                        placeholder="Select Assignee" optionLabelProp="label"
                                                                        showSearch onChange={handleAssigneeChange}
                                                                        //  onChange={(value) => { setAssignee(value); form.setFieldsValue({ followers: undefined }) }}
                                                                        filterOption={(input, option) => {
                                                                            const usernameElement = option.children.props.children[1].props.children[0];
                                                                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                const username = String(usernameElement.props.children);
                                                                                return username.toLowerCase().includes(input.toLowerCase());
                                                                            }
                                                                            return false;
                                                                        }
                                                                        }>
                                                                        {users}
                                                                    </Select> :
                                                                        <span className='user-info_image ListNavigate'
                                                                            role="button"
                                                                            tabIndex={0}
                                                                            onClick={() => displayData?.caseOwner && ViewDetailPage(displayData?.caseOwner, "USER")}
                                                                            onKeyDown={(event) => {
                                                                                if (event.key === 'Enter' || event.key === ' ') {
                                                                                    ViewDetailPage(displayData?.caseOwner, "USER");
                                                                                }
                                                                            }}
                                                                        >{displayData?.caseOwner && (
                                                                            displayData?.caseOwnerProfilePic !== null && displayData?.caseOwnerProfilePic
                                                                                !== undefined && displayData?.caseOwnerProfilePic !== "" ?
                                                                                <figure>
                                                                                    <img style={{ width: "30px", height: "30px" }} src={displayData?.caseOwnerProfilePic} alt="" />
                                                                                </figure>
                                                                                :
                                                                                <span className='list_span_Tag UserIcon'>
                                                                                    {displayData?.caseOwnerFirstName?.slice(0, 1).toUpperCase()}
                                                                                </span>)
                                                                            }{displayData?.caseOwner && (
                                                                                <figcaption>
                                                                                    {`${displayData?.caseOwnerFirstName} ${displayData?.caseOwnerLastName}`}
                                                                                </figcaption>)}</span>
                                                                    }
                                                                </Form.Item>
                                                            </Col>

                                                            <Col span={8} style={{ marginBottom: 20 }} >
                                                                <Form.Item label="Incident Type" name="type" id="type" rules={edit ? [{ required: true, message: 'Please select incident type' }] : [{ required: false }]} >
                                                                    {edit ? <Select style={{ width: '100%' }} allowClear placeholder="Select Incident Type" onChange={(value) => form.setFieldsValue({ type: value || null })}>
                                                                        <Option value="Safeguarding">Safeguarding</Option>
                                                                        <Option value="Medication error">Medication error</Option>
                                                                        <Option value="Fall">Fall</Option>
                                                                        <Option value="Injury">Injury</Option>
                                                                        <Option value="Self-harm">Self-harm</Option>
                                                                        <Option value="Aggression">Aggression</Option>
                                                                        <Option value="Absconding">Absconding</Option>
                                                                        <Option value="Pressure ulcer">Pressure ulcer</Option>
                                                                        <Option value="Infection">Infection</Option>
                                                                        <Option value="Deterioration">Deterioration</Option>
                                                                        <Option value="Behaviour incident">Behaviour incident</Option>
                                                                        <Option value="Communication failure">Communication failure</Option>
                                                                        <Option value="Property damage">Property damage</Option>
                                                                        <Option value="Fire / emergency">Fire / emergency</Option>
                                                                        <Option value="Data breach">Data breach</Option>
                                                                        <Option value="Staffing issue">Staffing issue</Option>
                                                                    </Select> :
                                                                        <span>{displayData?.caseType}</span>
                                                                    }
                                                                </Form.Item>
                                                            </Col>

                                                            <Col span={8} style={{ marginBottom: 20 }} >
                                                                <Form.Item label="Incident Status" name="status" initialValue={UrlId === undefined && "New"} id="status" rules={edit ? [{ required: true, message: 'Please select incident status' }] : [{ required: false }]}>
                                                                    {edit ? <Select style={{ width: '100%' }} allowClear placeholder="Select Incident status" onChange={(value) => form.setFieldsValue({ status: value || null })}>
                                                                        <Option value="New">New</Option>
                                                                        <Option value="Closed">Closed</Option>
                                                                        <Option value="On Hold">On Hold</Option>
                                                                        <Option value="Escalated">Escalated</Option>
                                                                    </Select> :
                                                                        <span>{displayData?.caseStatus}</span>
                                                                    }
                                                                </Form.Item>
                                                            </Col>

                                                            <Col span={8} style={{ marginBottom: 20 }} >
                                                                <Form.Item label="Incident Origin" name="origin" id="origin" rules={edit ? [{ required: true, message: 'Please select incident origin' }] : [{ required: false }]}>
                                                                    {edit ? <Select style={{ width: '100%' }} allowClear placeholder="Select Incident Origin" onChange={(value) => form.setFieldsValue({ origin: value || null })}>
                                                                        <Option value="Email">Email</Option>
                                                                        <Option value="Phone">Phone</Option>
                                                                        <Option value="Web">Web</Option>
                                                                        <Option value="Service user">Service user</Option>
                                                                        <Option value="Staff">Staff</Option>
                                                                        <Option value="Environmental">Environmental</Option>
                                                                        <Option value="Medical">Medical</Option>
                                                                        <Option value="System">System</Option>
                                                                        <Option value="Third-party">Third-party</Option>
                                                                        <Option value="Organisational">Organisational</Option>
                                                                    </Select> :
                                                                        <span>{displayData?.caseOrigin}</span>
                                                                    }
                                                                </Form.Item>
                                                            </Col>

                                                            <Col span={8} style={{ marginBottom: 20 }} >
                                                                <Form.Item label="Incident Priority" name="priority" id="priority">
                                                                    {edit ? <Select style={{ width: '100%' }} allowClear placeholder="Select Incident Priority" onChange={(value) => form.setFieldsValue({ priority: value || null })}>
                                                                        <Option value="Low">Low</Option>
                                                                        <Option value="Medium">Medium</Option>
                                                                        <Option value="High">High</Option>
                                                                    </Select> :
                                                                        <span>{displayData?.casePriority}</span>
                                                                    }
                                                                </Form.Item>
                                                            </Col>

                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Requested Resolution Date" name="isssueDate" id="isssueDate" rules={edit ?
                                                                    [{ required: true, message: 'Please select requested resolution date' },]
                                                                    : [{ required: false }]}>
                                                                    {edit ? <DatePicker allowClear={false} format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"} onChange={dealrestartDateChange2}
                                                                        disabledDate={disabledDate} />
                                                                        : <span >
                                                                            {displayData !== undefined && displayData.issueDate ? moment(displayData !== undefined && displayData.issueDate).format(profile.dateFormate) : (displayData !== undefined && displayData.issueDate && moment(displayData !== undefined && displayData.issueDate).format("YYYY-MM-DD"))}
                                                                        </span>}</Form.Item>
                                                            </Col>

                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Requester" name="creator" id="creator" rules={edit ? [{ required: true, message: 'Please select incident creator' }, {
                                                                    validator: (_, value) => {
                                                                        const error = nameOnChangeValidator(value, 50);
                                                                        if (error) {
                                                                            return Promise.reject(new Error(error));
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                }] : [{ required: false }]}>
                                                                    {edit ?
                                                                        <AutoComplete
                                                                            options={creatorList?.map(option => ({
                                                                                label: (<div className='UserList-dropdown' title={`${option.name} (${option.type})`}>
                                                                                    <div>
                                                                                        <span className={`details_span_Tag ${option.type === "Leads" ? "LeadIcon" : "ContactIcon"}`} style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                            {option.name.slice(0, 1).toUpperCase()}
                                                                                        </span>
                                                                                    </div>
                                                                                    <div>
                                                                                        <p style={{ fontWeight: 'bold', margin: 0 }}>{option.name}</p>
                                                                                        <p style={{ margin: 0 }}>({option.type})</p>
                                                                                    </div>
                                                                                </div>),
                                                                                value: `${option.name}-${option.type}-${option.id}`,
                                                                                data: option
                                                                            }))}
                                                                            onChange={handleCreatorChange}
                                                                            onSelect={(value, option) => handleSelect(option.data)}
                                                                            style={{ width: '100%' }}
                                                                            placeholder="Type or select an option"
                                                                            filterOption={(inputValue, option) =>
                                                                                option.value.toLowerCase().includes(inputValue.toLowerCase())
                                                                            }
                                                                        >
                                                                            <Input />
                                                                        </AutoComplete>
                                                                        :
                                                                        <span className='text_icon'>
                                                                            {displayData?.caseCreater}
                                                                        </span>
                                                                    }
                                                                </Form.Item>
                                                            </Col>

                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Requester Email" name="email"
                                                                    id="email" rules={edit ? [{ required: true, message: 'Please enter incident creator email', }, {
                                                                        validator: (_, value) => {
                                                                            const error = validateEmailField(value, 50);
                                                                            if (error) {
                                                                                return Promise.reject(new Error(error));
                                                                            }
                                                                            return Promise.resolve();
                                                                        },
                                                                    }] : [{ required: false }]} >
                                                                    {edit ? <Input placeholder="Enter Requester Email" disabled={disabled || fromEmail === "fromEmail"} /> :
                                                                        <span>{displayData?.caseCreaterEmail}</span>
                                                                    }
                                                                </Form.Item>
                                                            </Col>

                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Requester Phone Number" name="phone"
                                                                    id="phone" rules={[{
                                                                        validator: (_, value) => {
                                                                            const error = mobileOnChangeValidator(value, 20);
                                                                            if (error) {
                                                                                return Promise.reject(new Error(error));
                                                                            }
                                                                            return Promise.resolve();
                                                                        },
                                                                    },]}>
                                                                    {edit ? <Input placeholder="Enter Requester Phone Number" pattern="^\+?[0-9]{1,14}$" /> :
                                                                        <span>{displayData?.caseCreaterNumber}</span>
                                                                    }
                                                                </Form.Item>
                                                            </Col>

                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Sponsor Name" name="accountname"
                                                                    id="accountname" rules={[{
                                                                        validator: (_, value) => {
                                                                            const error = nameOnChangeValidator(value, 50);
                                                                            if (error) {
                                                                                return Promise.reject(new Error(error));
                                                                            }
                                                                            return Promise.resolve();
                                                                        },
                                                                    }]}
                                                                // rules={edit ? [{ required: true, message: 'Please select account' }] : [{ required: false }]}
                                                                >
                                                                    {edit ? <Input placeholder="Enter Sponsor Name" disabled={disabled} /> :
                                                                        <span>{displayData?.accountName}</span>
                                                                        // <span className='user-info_image ListNavigate'
                                                                        //     role="button"
                                                                        //     tabIndex={0}
                                                                        //     onClick={() => displayData?.accountId && ViewDetailPage(displayData?.accountId, "ACCOUNT")}
                                                                        //     onKeyDown={(event) => {
                                                                        //         if (event.key === 'Enter' || event.key === ' ') {
                                                                        //             ViewDetailPage(displayData?.accountId, "ACCOUNT");
                                                                        //         }
                                                                        //     }}
                                                                        // >{displayData?.accountId && (
                                                                        //     displayData?.accountProfile !== null && displayData?.accountProfile
                                                                        //         !== undefined && displayData?.accountProfile !== "" ?
                                                                        //         <figure>
                                                                        //             <img style={{ width: "30px", height: "30px" }} src={displayData?.accountProfile} alt="" />
                                                                        //         </figure>
                                                                        //         :
                                                                        //         <span className='list_span_Tag AccountIcon'>
                                                                        //             {displayData?.accountName?.slice(0, 1).toUpperCase()}
                                                                        //         </span>)
                                                                        //     }{displayData?.accountId && (
                                                                        //         <figcaption>
                                                                        //             {displayData?.accountName}
                                                                        //         </figcaption>)}</span>
                                                                    }
                                                                </Form.Item>
                                                            </Col>

                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Parent Incident" name="parentCase"
                                                                    id="parentCase">
                                                                    {edit ? <Select style={{ width: '100%' }}
                                                                        placeholder="Select Parent Incident"
                                                                        showSearch allowClear optionLabelProp="label"
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) => {
                                                                            const usernameElement = option.children.props.children[1].props.children[0];
                                                                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                const username = String(usernameElement.props.children);
                                                                                return username.toLowerCase().includes(input.toLowerCase());
                                                                            }
                                                                            return false;
                                                                        }
                                                                        }
                                                                        onChange={handleParentCaseChange}
                                                                    >
                                                                        {allList.filter((item) => item.caseId !== caseId).map((option, i) => (
                                                                            <Option value={option.caseId} key={i} label={(
                                                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                                    <div className='Div_flex2'>
                                                                                        <div className='share_image' title={`${option.caseSubject} (${option.caseNumber})`} style={{ cursor: "default" }}>
                                                                                            <span className="image_icon">
                                                                                                {option.caseSubject.slice(0, 1).toUpperCase()}
                                                                                            </span>
                                                                                            <span className='div-ellipsis'>{option.caseSubject}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>)}>
                                                                                <div className='UserList-dropdown' title={`${option.caseSubject} (${option.caseNumber})`}>
                                                                                    <div>
                                                                                        <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                            {option.caseSubject.slice(0, 1).toUpperCase()}
                                                                                        </span>
                                                                                    </div>
                                                                                    <div>
                                                                                        <p style={{ fontWeight: 'bold', margin: 0 }}>{option.caseSubject}</p>
                                                                                        <p style={{ margin: 0 }}>{option.caseNumber}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </Option>))}
                                                                    </Select> :
                                                                        <span>{displayData?.accountName}</span>

                                                                    }
                                                                </Form.Item>
                                                            </Col>

                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Child Incidents" name="childCases"
                                                                    id="childCases">
                                                                    {edit ? <Select style={{ width: '100%' }}
                                                                        placeholder="Select Child Incidents"
                                                                        mode="multiple"
                                                                        showSearch optionLabelProp="label"
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) => {
                                                                            const usernameElement = option.children.props.children[1].props.children[0];
                                                                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                const username = String(usernameElement.props.children);
                                                                                return username.toLowerCase().includes(input.toLowerCase());
                                                                            }
                                                                            return false;
                                                                        }
                                                                        }
                                                                        dropdownRender={(menu) => (
                                                                            <>
                                                                                {menu}
                                                                                <Divider style={{ margin: '8px 0' }} />
                                                                                <Space style={{
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    justifyContent: "center",
                                                                                    marginBottom: "-10px"
                                                                                }}>
                                                                                    <AntdButton type="text" onClick={() => setAddAccount(true)} icon={<PlusCircleOutlined />}>
                                                                                        Add Incident
                                                                                    </AntdButton>
                                                                                </Space>
                                                                            </>
                                                                        )}
                                                                    >
                                                                        {allList.filter((item) => item.caseId !== caseId)
                                                                            .filter((item) => item.caseId !== parentCase)
                                                                            .map((option, i) => (
                                                                                <Option value={option.caseId} key={i} label={(
                                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.caseSubject} (${option.caseNumber})`}>
                                                                                        <span className='details_span_Tag' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                                                                            {option.caseSubject.slice(0, 1).toUpperCase()}
                                                                                        </span>

                                                                                        <p style={{ fontWeight: 'bold', margin: 0 }}>{option.caseSubject}</p>
                                                                                    </div>)}>
                                                                                    <div className='UserList-dropdown' title={`${option.caseSubject} (${option.caseNumber})`}>
                                                                                        <div>
                                                                                            <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                                {option.caseSubject.slice(0, 1).toUpperCase()}
                                                                                            </span>
                                                                                        </div>
                                                                                        <div>
                                                                                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.caseSubject}</p>
                                                                                            <p style={{ margin: 0 }}>{option.caseNumber}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </Option>))}
                                                                    </Select> :
                                                                        <span>{displayData?.accountName}</span>
                                                                    }
                                                                </Form.Item>
                                                            </Col>

                                                            <Col span={8} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Followers" name="followers" id="followers">
                                                                    {edit ? <Select style={{ width: '100%' }}
                                                                        mode="multiple"
                                                                        placeholder="Select Followers"
                                                                        showSearch optionLabelProp="label"
                                                                        filterOption={(input, option) => {
                                                                            const usernameElement = option.children.props.children[1].props.children[0];
                                                                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                const username = String(usernameElement.props.children);
                                                                                return username.toLowerCase().includes(input.toLowerCase());
                                                                            }
                                                                            return false;
                                                                        }
                                                                        }>
                                                                        {users2
                                                                            .filter((item) => item.userId !== assignee)
                                                                            .map((option, i) => (
                                                                                <Option value={option.userId} key={i} label={(
                                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.firstName} ${option.lastName} (${option.username})`}>
                                                                                        {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                            < img src={option.profilePic} alt="profile" style={{ width: '20px', height: '20px', borderRadius: 20 }} />
                                                                                            :
                                                                                            <span className='details_span_Tag UserIcon' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                                                                                {option.firstName.slice(0, 1).toUpperCase()}
                                                                                            </span>
                                                                                        }
                                                                                        <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                                                                                    </div>
                                                                                )}>
                                                                                    <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                                                                                        <div>
                                                                                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                                                                                < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                                                                                :
                                                                                                <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                                                                                    {option.firstName.slice(0, 1).toUpperCase()}
                                                                                                </span>
                                                                                            }</div>
                                                                                        <div>
                                                                                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                                                                                            <p style={{ margin: 0 }}>{option.username}</p>
                                                                                        </div>
                                                                                    </div>
                                                                                </Option>))}
                                                                    </Select> :
                                                                        <span>{displayData?.Followers}</span>
                                                                    }
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                        <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                            <Col span={24} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Description" name="description" id="description" rules={
                                                                    [
                                                                        {
                                                                            validator: (_, value) => {
                                                                                const error = validateDescriptionField(value, 2500);
                                                                                if (error) {
                                                                                    return Promise.reject(new Error(error));
                                                                                }
                                                                                return Promise.resolve();
                                                                            },
                                                                        },
                                                                    ]
                                                                }>
                                                                    {edit ? <Input.TextArea rows={3} maxLength={2500} showCount placeholder='Enter Description' /> :
                                                                        <span>{displayData?.description}</span>
                                                                    }
                                                                </Form.Item>
                                                            </Col>

                                                            <Col span={24} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Solution" name="solution" id="solution" rules={
                                                                    [
                                                                        {
                                                                            validator: (_, value) => {
                                                                                const error = validateDescriptionField(value, 2500);
                                                                                if (error) {
                                                                                    return Promise.reject(new Error(error));
                                                                                }
                                                                                return Promise.resolve();
                                                                            },
                                                                        },
                                                                    ]
                                                                }>
                                                                    {edit ? <Input.TextArea rows={3} maxLength={2500} showCount placeholder='Enter Solution' /> :
                                                                        <span>{displayData?.solution}</span>
                                                                    }
                                                                </Form.Item>
                                                            </Col>

                                                            <Col span={24} style={{ marginBottom: 20 }}>
                                                                <Form.Item label="Comment" name="comment" id="comment" rules={
                                                                    [
                                                                        {
                                                                            validator: (_, value) => {
                                                                                const error = validateDescriptionField(value, 2500);
                                                                                if (error) {
                                                                                    return Promise.reject(new Error(error));
                                                                                }
                                                                                return Promise.resolve();
                                                                            },
                                                                        },
                                                                    ]
                                                                }>
                                                                    {edit ? <Input.TextArea rows={3} maxLength={2500} showCount placeholder='Enter Comment' /> :
                                                                        <span>{displayData?.comment}</span>
                                                                    }
                                                                </Form.Item>
                                                            </Col>

                                                            {(UrlId !== undefined && UrlId !== null && UrlId[0] === "?CASE") ? <>
                                                                <Col span={24} style={{ marginBottom: 20 }}>
                                                                    <Form.Item label="Internal Comments">
                                                                        <div style={{ position: 'relative', width: '100%' }}>
                                                                            <Input.TextArea
                                                                                placeholder="Enter Internal Comments"
                                                                                rows={3}
                                                                                maxLength={2500} showCount
                                                                                value={notes}
                                                                                onChange={(e) => {
                                                                                    const inputValue = e.target.value;
                                                                                    const error = validateDescriptionField(inputValue, 2500);
                                                                                    if (error) {
                                                                                        message.error(error);
                                                                                        return;
                                                                                    }
                                                                                    setNotes(inputValue);
                                                                                }}
                                                                                style={{ paddingRight: '100px' }}
                                                                            />
                                                                            <Button
                                                                                disabled={notes === null || notes === undefined || notes === ''}
                                                                                className="button_colors"
                                                                                onClick={handleAddNote}
                                                                                style={{ position: 'absolute', right: '20px', bottom: '5px' }}
                                                                            >
                                                                                Add
                                                                            </Button>
                                                                        </div>
                                                                    </Form.Item>
                                                                </Col>

                                                                <Col span={24} style={{ marginBottom: 20 }}>
                                                                    <div>
                                                                        {allNotes &&
                                                                            allNotes?.map((note, index) => {
                                                                                return (
                                                                                    <div
                                                                                        key={index}
                                                                                        className="cnote-card"
                                                                                        style={{
                                                                                            backgroundColor: '#F5F5F7',
                                                                                            color: '#134B70',
                                                                                            padding: 10,
                                                                                            borderRadius: 5,
                                                                                            marginTop: 10,
                                                                                        }}
                                                                                    >
                                                                                        <div
                                                                                            style={{
                                                                                                display: 'flex',
                                                                                                gap: 10,
                                                                                                justifyContent: 'space-between',
                                                                                            }}
                                                                                        >
                                                                                            <p style={{ fontSize: 12 }}>{note.name}</p>
                                                                                            <div style={{ fontSize: 12, gap: 10, display: "flex", alignItems: "center" }}>
                                                                                                <p>{convertAndFormatDateTime2(note.time, companyProfile, profile)}</p>
                                                                                                {profile.userId === note.id &&
                                                                                                    <p className="cdelete-icon"><FeatherIcon icon="trash-2" size={16} style={{ color: "red", cursor: "pointer" }} onClick={() => NoteDelete(index)} /></p>}
                                                                                            </div>
                                                                                        </div>
                                                                                        <p>{note.content}</p>
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                    </div>
                                                                </Col>

                                                            </> : ""}
                                                        </Row>
                                                        <RelatedDocUpload edit={edit} FILEList={FILEList} setFileList={setFileList} form={form} />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                </BasicFormWrapper>
                            </Form>
                        </div>
                    </AddUser>
                </Scrollbars> :
                    <div className="spin">
                        <Spin />
                    </div>}
            </Drawer >
            {isModalVisible1 && <UpdateConnectionPopup confirmPopup={isModalVisible1} setConfirmPopup={setIsModalVisible1} Respone={errorData} page="Details" type="Case" getCallBack={getRefreshtheTable} />}
            {cancelConfirmOpen && <AllCancelPopup confirmPopup={cancelConfirmOpen} setConfirmPopup={setCancelConfirmOpen} GetCallback={CloseDrawer} />}
            <AddTaskPage UrlId={undefined} FromPage={createPageTask} setCratePage={setCreatePageTask} CallBackTrigger={setNaCTrigger} fromPageforTask="FromDetails" taskProp={taskProp} />
            {callLogPopup && <CallLogPopup AutomationMessage={AutomationMessage} setCallLogPopup={setCallLogPopup} callLogPopup={callLogPopup} popupType={popupType} UrlId={UrlId ? [UrlId[0], caseId] : null} setNaCTrigger={setNaCTrigger} />}
            <ComposeMail mailOpen={mailOpen} close={closeMailComposr} entityName="cases" entity="EntityPages" toId={[displayData?.caseCreaterEmail]} SubjectData={SubjectData} setNaCTrigger={setNaCTrigger} MailContent={threadContent} />
            {addAccount && <AddCasePopup addAccount={addAccount} setAddAccount={setAddAccount} AccountApi={getList} Callback={Callback} pageType="Case" successMessage={successMessage} />}
            {confirmPopup && <ConfirmationPopup confirmPopup={confirmPopup} setConfirmPopup={setConfirmPopup} GetCallback={deleteMenu} deleteId={deleteId} />}
            {popupMessage && <DefaultMessagePopup messagePopup={popupMessage} setMessagePopup={setPopupMessage} pageType={pages} onNavigate={onnavigate} />}
            {isModalVisible && <DeleteConnectionPopup confirmPopup={isModalVisible} setConfirmPopup={HandleIsModalVisible} Respone={errorData} page="Details" type="Case" getCallBack={getRefreshtheTable} />}
        </>
    );
}

AddNew.propTypes = {
    UrlId: PropTypes.array.isRequired,
    MailData: PropTypes.object.isRequired,
    ShortCut: PropTypes.string.isRequired,
    fromEmail: PropTypes.string.isRequired,
    FromPage: PropTypes.string.isRequired,
    setCratePage: PropTypes.func.isRequired,
    GetAll: PropTypes.func.isRequired,
    CallBack: PropTypes.func.isRequired,
};

export default AddNew;